/*
 * @Author: yuankun yuankun0310@126.com
 * @Date: 2022-06-27 16:29:33
 * @LastEditors: yuankun yuankun0310@126.com
 * @LastEditTime: 2022-06-30 19:37:50
 * @FilePath: /shopManagement/src/models/purseSet.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import service from "@/service/chat_api";
import purseApi from "../service/basic/purseApiList";
const myhost = myhostname;

/**
 * @export
 * @param {*} params
 * @returns Prmoise
 * @description 查询公司列表
 */
export function getCompanyList(params) {
  return new Promise((resolve, reject) => {
    service
      .get(`${myhost}${purseApi.companyList}`, {
        params
      })
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
}

/**
 * @export
 * @param {*} params
 * @returns Prmoise
 * @description 查询公司下钱袋信息
 */
export function getPurseList(params) {
  return new Promise((resolve, reject) => {
    service
      .get(`${myhost}${purseApi.pursList}`, {
        params
      })
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
}

/**
 * @export
 * @param {*} params
 * @returns Prmoise
 * @description 查询公司下账户信息
 */
export function getAccountInfo(params) {
  return new Promise((resolve, reject) => {
    service
      .get(`${myhost}${purseApi.accountInfo}`, { params })
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
}

/**
 * @export
 * @param {*} params
 * @returns Prmoise
 * @description 查询当前公司是否开通清分账户
 */
export function getCheckOpenLian(params) {
  return new Promise((resolve, reject) => {
    service
      .get(`${myhost}${purseApi.checkOpenLian}`, { params })
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
}
/**
 * @export
 * @param {*} params
 * @returns Prmoise
 * @description 申请提现 获取提现码
 */
export function cashMarkCode(params) {
  return new Promise((resolve, reject) => {
    service
      .post(`${myhost}${purseApi.applyWithdrawal}`, params)
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
}

/**
 * @export
 * @param {*} params
 * @returns Prmoise
 * @description 发送验证码
 */
export function sendCheckCode(params) {
  return new Promise((resolve, reject) => {
    service
      .post(`${myhost}${purseApi.checkCode}`, params)
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
}

/**
 * @export
 * @param {*} params
 * @returns Prmoise
 * @description 确认提现
 */
export function sureCashCode(params) {
  return new Promise((resolve, reject) => {
    service
      .post(`${myhost}${purseApi.confirmCash}`, params)
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
}

/**
 * @export
 * @param {*} params
 * @returns Prmoise
 * @description 计算扣除手续后 实际到账金额 连连钱袋调用
 */
export function getRealAmount(params) {
  return new Promise((resolve, reject) => {
    service
      .get(`${myhost}${purseApi.realAmount}`, {
        params
      })
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
}

/**
 * @export
 * @param {*} params
 * @returns Prmoise
 * @description 获取提现账户相关信息
 */
export function cashRelateInfo(params) {
  return new Promise((resolve, reject) => {
    service
      .get(`${myhost}${purseApi.cashRelateInfo}`, {
        params
      })
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
}

/**
 * @export
 * @param {*} params
 * @returns Prmoise
 * @description 获取清分账户是否开启
 */
export function checkLian(params) {
  return new Promise((resolve, reject) => {
    service
      .get(`${myhost}${purseApi.flagLian}`, {
        params
      })
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
}

/**
 * @export
 * @param {*} params
 * @returns Prmoise
 * @description 获取钱袋交易记录
 */
export function getTransactionRecords(params) {
  return new Promise((resolve, reject) => {
    service
      .get(`${myhost}${purseApi.transactionRecords}`, {
        params
      })
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
}

/**
 * @export
 * @param {*} params
 * @returns Prmoise
 * @description 获取清分账户 激活 换绑手机号 换绑银行卡操作当前状态
 */
export function getStatusFlag(params) {
  return new Promise((resolve, reject) => {
    service
      .get(`${myhost}${purseApi.statusFlag}`, {
        params
      })
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
}

/**
 * @export
 * @param {*} params
 * @returns Prmoise
 * @description 获取交易类型枚举
 */
export function getTransactionType(params) {
  return new Promise((resolve, reject) => {
    service
      .get(`${myhost}${purseApi.transactionType}`, {
        params
      })
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
}

/**
 * @export
 * @param {*} params
 * @returns Prmoise
 * @description 获取连连交易明细流水详情
 */
export function getLianLianDetailItem(params) {
  return new Promise((resolve, reject) => {
    service
      .get(`${myhost}${purseApi.lianLianDetailItem}`, {
        params
      })
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
}

// 免密协议url（重签）
export function postPapAgreeApply(params) {
  return new Promise((resolve, reject) => {
    service
      .post(`${myhost}${purseApi.papAgreeApply}`, params)
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
}
// 免密协议url(修改)
export function putPapAgreeModify(params) {
  return new Promise((resolve, reject) => {
    service
      .put(`${myhost}${purseApi.papAgreeModify}`, params)
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
}

// 免密协议是否过期
export function getPapAgreeApply(params) {
  return new Promise((resolve, reject) => {
    service
      .get(`${myhost}${purseApi.papAgreeQuery}`, { params })
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
}

// 判断是否激活
export function getStatusFlagNew(params) {
  return new Promise((resolve, reject) => {
    service
      .get(`${myhost}${purseApi.queryStatusFlag}`, { params })
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
}



// WEBPACK FOOTER //
// ./src/models/purseSet.js